import { gql } from 'apollo-boost';

export const mapShapeDestroy = gql`
    mutation mapShapeDestroy($input: MapShapeDestroyMutationInput!) {
        mapShapeDestroy(input: $input) {
            deletedId
            clientMutationId
        }
    }
`;

export const mapShapeCreate = gql`
    mutation mapShapeCreate($input: MapShapeCreateMutationInput!) {
        mapShapeCreate(input: $input) {
            mapShape {
                id
                name
                shape {
                    id
                    geojsonUrl
                    shapeGroup {
                        id
                        name
                    }
                }
            }
            clientMutationId
        }
    }
`;

export const mapShapeGroupDestroy = gql`
    mutation mapShapeGroupDestroy($input: MapShapeGroupDestroyMutationInput!) {
        mapShapeGroupDestroy(input: $input) {
            deletedIds
            clientMutationId
        }
    }
`;

export const mapShapeGroupCreate = gql`
    mutation mapShapeGroupCreate($input: MapShapeGroupCreateMutationInput!) {
        mapShapeGroupCreate(input: $input) {
            mapShapes {
                id
                name
                shape {
                    id
                    geojsonUrl
                    shapeGroup {
                        id
                        name
                    }
                }
            }
            clientMutationId
        }
    }
`;
